export default {"src":"/stays/_next/static/media/HotelsRating.bf57dd69.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};